import level_1 from '@inspector/assets/common/level_first.png';
import level_2 from '@inspector/assets/common/level_second.png';
import level_3 from '@inspector/assets/common/level_third.png';
import level_4 from '@inspector/assets/common/level_fourth.png';
export const ProductKey = 'inspector';

export const AlarmColumns = [
  {
    title: '告警模块',
    dataIndex: 'module',
    align: 'left',
  },
  {
    title: '告警内容',
    dataIndex: 'errorMsg',
    align: 'left',
  },
  {
    title: '告警码',
    dataIndex: 'errorCode',
    align: 'left',
  },
  {
    title: '告警次数',
    dataIndex: 'errorCount',
    align: 'left',
  },
  {
    title: '首次告警时间',
    dataIndex: 'earliestReportTime',
    align: 'left',
  },
  {
    title: '最新告警时间',
    dataIndex: 'latestReportTime',
    align: 'left',
  },
];

export enum AlarmCode {
  VEHICLE_STOP_TIMEOUT = 'VEHICLE_STOP_TIMEOUT',
  LOW_BATTERY = 'LOW_BATTERY',
  VEHICLE_CRASH = 'VEHICLE_CRASH',
}

export enum AlarmLevel {
  ALARM_URGENT = 'ALARM_URGENT',
  ALARM_MAJOR = 'ALARM_MAJOR',
  ALARM_NORMAL = 'ALARM_NORMAL',
  ALARM_SLIGHT = 'ALARM_SLIGHT',
}
export const AlarmLevelMap = {
  [AlarmLevel.ALARM_URGENT]: level_1,
  [AlarmLevel.ALARM_MAJOR]: level_2,
  [AlarmLevel.ALARM_NORMAL]: level_3,
  [AlarmLevel.ALARM_SLIGHT]: level_4,
};

export const Mode = [
  {
    label: '看板模式',
    value: 'boardMode',
    isActive: true,
  },
  {
    label: '地图模式',
    value: 'mapMode',
    isActive: false,
  },
];


export enum LayerId {
  BASE_IMAGE_MAP = 'BASE_IMAGE_MAP',
  ROAD_MAP = 'ROAD_MAP',
  POINT_MAP = 'POINT_MAP',
  AREA_MAP = 'AREA_MAP',
  POINT_NAME = 'POINT_NAME',
  DEVICE_POINT = 'DEVICE_POINT',
  STOP_POINT = 'STOP_POINT',
  GEOMETRY = 'GEOMETRY',
  STOP_NAME = 'STOP_NAME',
  DEVICE_POINT_LIST = 'DEVICE_POINT_LIST',
  ARROW_LAYER = 'ARROW_LAYER',
  SCHEDULED_ROUTE_LAYER = 'SCHEDULED_ROUTE_LAYER',
  SCHEDULED_ARROW_LAYER = 'SCHEDULED_ARROW_LAYER',
}


export const iconMap: any = new Map([ 
  ['NORMAL', require('@warehouse/assets/common/blue.png')],
  ['SEVERITY', require('@warehouse/assets/common/orange.png')],
  ['CRITICAL', require('@warehouse/assets/common/red.png')],
]);

export const iconHighlightMap: any = new Map([
  ['NORMAL', require('@warehouse/assets/common/blue_highlight.png')],
  ['SEVERITY', require('@warehouse/assets/common/orange_highlight.png')],
  ['CRITICAL', require('@warehouse/assets/common/red_highlight.png')],
]);

export const OFFLINE_ICON = require('@warehouse/assets/common/offline_ico.png');
